import { render } from "./SplashScreen.vue?vue&type=template&id=c25f609c&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=c25f609c&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Vue\\intensione\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c25f609c"]])

export default __exports__